export const getEntities = state => state.entities; // eslint-disable-line
